import React, { FC, HTMLAttributes } from "react";

const HometownTaxVideoBanner: FC<HTMLAttributes<HTMLImageElement>> = ({ ...props }) => (
  <img src="/image/banner/animefurusato/video-explain.jpg" width="300" height="63" loading="lazy" {...props} />
);
export default HometownTaxVideoBanner;
